import Vue from "vue";
import Vuetify from "vuetify/lib";

import fr from "vuetify/es5/locale/fr";
import en from "vuetify/es5/locale/en";

Vue.use(Vuetify);

// Stale themeCache used String(object) === "[object Object]" as key, so dark
// custom properties were served in light mode. Drop the bad entry once.
try {
  localStorage.removeItem("[object Object]");
} catch { /* ignore */ }

export default new Vuetify({

  treeShake: true,
  defaultAssets: {
    font: {
      family: "Poppins",
    },
  },
  icons: {
    iconfont: "mdi", // https://materialdesignicons.com/cdn/2.0.46/
  },
  theme: {
    dark: true,
    options: {
      customProperties: true,
    },
    themes: {
      dark: {
        primary: "#4879a7",
        accent: "#FF4081",
        secondary: "#ffe18d",
        success: "#4CAF50",
        info: "#f3bb21",
        warning: "#FB8C00",
        error: "#FF5252",
        background: "#262b35",
        surface: "#2f3742",
        neutral: "#b9bec7",
      },
      light: {
        primary: "#4879a7",
        accent: "#e91e63",
        secondary: "#30b1dc",
        success: "#4CAF50",
        info: "#f3bb21",
        warning: "#FB8C00",
        error: "#FF5252",
        background: "#eef1f4",
        surface: "#f7f8fa",
        neutral: "#262b35",
      },
    },
  },
  lang: {
    locales: {
      fr,
      en,
    },
    current: "fr",
  },
});
